import React from 'react'

export function GoalsHealthTable({ rows = [], onRowClick }) {
  if (!rows.length) {
    return <div style={styles.empty}>No goals have been set yet.</div>
  }
  return (
    <table style={styles.table}>
      <thead>
        <tr style={styles.headRow}>
          <th style={styles.th}>Report</th>
          <th style={styles.th}>Manager</th>
          <th style={styles.thNum}>Goals</th>
          <th style={styles.thNum}>At risk</th>
          <th style={styles.thNum}>Achieved</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((r) => (
          <tr
            key={r.reportId}
            style={{ ...styles.row, cursor: onRowClick ? 'pointer' : 'default' }}
            onClick={() => onRowClick && onRowClick(r)}
          >
            <td style={styles.td}>
              <div style={styles.reportName}>{r.reportName}</div>
              <div style={styles.managerSub}>{r.managerName}</div>
            </td>
            <td style={styles.td}>{r.managerName}</td>
            <td style={styles.tdNum}>{r.totalGoals}</td>
            <td style={styles.tdNum}>
              {r.atRiskGoals > 0 ? <span style={styles.pillRed}>{r.atRiskGoals}</span> : '—'}
            </td>
            <td style={styles.tdNum}>
              {r.achievedGoals > 0 ? <span style={styles.pillGreen}>{r.achievedGoals}</span> : '—'}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}

const styles = {
  table: { width: '100%', borderCollapse: 'collapse', fontSize: 13 },
  headRow: { borderBottom: '1px solid var(--border)' },
  th: { textAlign: 'left', padding: '8px 10px', fontSize: 11, color: 'var(--text-secondary)', textTransform: 'uppercase', letterSpacing: 0.4 },
  thNum: { textAlign: 'right', padding: '8px 10px', fontSize: 11, color: 'var(--text-secondary)', textTransform: 'uppercase', letterSpacing: 0.4 },
  row: { borderBottom: '1px solid var(--border)' },
  td: { padding: '10px' },
  tdNum: { padding: '10px', textAlign: 'right', fontVariantNumeric: 'tabular-nums' },
  reportName: { fontWeight: 600 },
  managerSub: { fontSize: 11, color: 'var(--text-secondary)' },
  pillRed: { background: '#F8D6D3', color: '#8A2A22', padding: '2px 8px', borderRadius: 10, fontWeight: 600 },
  pillGreen: { background: '#E5F0D6', color: '#3F6313', padding: '2px 8px', borderRadius: 10, fontWeight: 600 },
  empty: { fontSize: 13, color: 'var(--text-secondary)', padding: 16, textAlign: 'center' },
}
